module.exports = __webpack_public_path__ + "img/logo-genesis.9dfacf55.svg";